export default __webpack_public_path__ + "static/media/nucleot_icon.d143b0f9.svg";